<template>
  <AbsPopup id="LoginPopup" title="로그인" type="alert" :initButtonList="buttonList" @close="$emit('close')">
    <template #body>
      <article class="auth">
        <div class="inputCanvas">
          <span class="guide">스담에 오신걸 환영합니다.</span>
          <ul class="join">
            <UInput id="email" type="text" tag="li" placeholder="" v-model="email" @enter="emailEnter">
              <div class="inputTitle">
                <span><b>이메일</b></span><span class="require">*</span>
              </div>
            </UInput>
            <li></li>
            <UInput id="password" type="password" tag="li" placeholder="" v-model="pass" @enter="passEnter">
              <div class="inputTitle">
                <span><b>비밀번호</b></span><span class="require">*</span>
              </div>
            </UInput>
            <li>
              <span @click="accountSearch" class="accountSearch">계정 찾기</span>
              <span @click="create" class="create">회원 가입</span>
            </li>
          </ul>
          <Ubutton size="medium" text="로그인" state="deactive" @click.native="login"/>
          <div class="contour">
            <span></span>
            <span class="text">또는</span>
            <span></span>
          </div>
          <ul class="easyjoin">
            <li class="createTmekaAuth" @click="href('/api/auth/google?name=' + getName + getParam)">
              <icon size="medium" icon="google"/>
            </li>
            <li class="createTmekaAuth" @click="href('/api/auth/facebook?name=' + getName + getParam)">
              <icon size="medium" icon="facebook"/>
            </li>
            <li class="createTmekaAuth" @click="href('/api/auth/kakao?name=' + getName + getParam)">
              <icon size="medium" icon="kakao"/>
            </li>
            <li class="createTmekaAuth" @click="href('/api/auth/naver?name=' + getName + getParam)">
              <icon size="medium" icon="naver"/>
            </li>
          </ul>
        </div>
      </article>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    console.log(this.option)
    this.$emit('loading', false)
  },
  beforeDestroy () {
  },
  data () {
    return {
      email: '',
      pass: ''
    }
  },
  name: 'LoginPopup',
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }}
      ]
    },
    getName () {
      console.log('getName', this.option.param)
      return this.option.param.name
    },
    getParam () {
      console.log('getParam', this.option.param.param)
      if (this.option.param.param) {
        var st = ''
        for (var n in this.option.param.param) {
          console.log(n)
          st += '&' + n + '=' + this.option.param.param[n]
        }
        return st
      } else {
        return ''
      }
    }
  },
  methods: {
    login () {
      if (this.email !== '' && this.pass !== '') {
        this.$http.post('/api/auth/login', {email: this.email, pass: this.pass}).then((e) => {
          if (e.success) {
            console.log(e)
            this.$store.dispatch('logIn', e.data)
            this.$emit('submit')
          } else {
            // 통신에러?
            if (e.state === 4) {
              this.alert({
                title: '휴면 계정 재사용 안내',
                titleState: 'require',
                require: true,
                message: '<span class="description">스담 서비스를 오랫동안 이용하지 않아</span><br />' +
                '<span class="description">회원님의 아이디가 휴면 상태로 전환되었습니다.</span><br /><br />' +
                '<span class="description">스담 서비스를 다시 이용하고 싶은 경우에는</span><br />' +
                '<span  class="description">아래 \'휴면 해지하기\' 버튼을 클릭해주세요</span>',
                buttonText: '휴면 해지하기'
              }, () => {
                this.openPopup('CertPopup', {email: this.email, state: 0, type: 'dormancy'})
              })
            } else {
              this.alert('<span class="require">이메일 또는 비밀번호를 다시 확인하세요</span><br />' +
              '<span>등록되지 않은 아이디이거나, 비밀번호를 잘못 입력하셧습니다.</span><br /><br />' +
              '<span class="description">문의사항이 있으시면 아래 이메일로 문의 바랍니다.</span><br />' +
              '<span  class="description">support@tmeka.com</span>', '107', true)
            }
          }
        })
      }
    },
    emailEnter () {
      document.querySelector('#password').focus()
    },
    passEnter () {
      this.login()
    },
    accountSearch () {
      this.$router.push({name: 'accountSearch'})
      this.$emit('submit')
    },
    create () {
      this.$router.push({name: 'join'})
      this.$emit('submit')
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#LoginPopup {
  padding: 10px 0;
  width: 450px;
  color: var(--text-base);
}
.auth {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 100%;
  margin: auto;
  padding-top: 30px;
}
.inputCanvas {
  display: flex;
  flex-direction: column;
}
.inputCanvas > span {
  color: var(--text-base);
}
.join {
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-top: 40px;
  margin-bottom: 5px;
}
.join li {
  display: flex;
  align-items: center;
  height: 35px;
}
.inputTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 80px;
}
.auth .input {
  width: 100%;
}
.join li:last-child {
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;
  margin: 10px 0px;
}
.join li:last-child a {
  font-size: 0.8em;
}
.contour {
  width: 100%;
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--line-base);
}
.contour .text {
  margin: 0px 10px;
}
.contour span:first-child {
  flex: 1;
  border-bottom: 1px solid var(--line-base);
}
.contour span:last-child {
  flex: 1;
  border-bottom: 1px solid var(--line-base);
}
.easyjoin {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  margin-bottom: 20px;
}
.createTmekaAuth {
  /* flex: 1; */
  display: flex;
  /* flex-direction: row; */
  /* align-items: center; */
  cursor: pointer;
}
.accountSearch, .create{
  font-size: 0.8em;
  color: var(--icon-base);
  cursor: pointer;
}
.createTmekaAuth span:nth-child(2){
  margin-left: 10px;
  padding-bottom: 2px;
}
.createTmekaAuth .google {
  background-image: url('~@/assets/icon/logo-google.png');
}
.createTmekaAuth .google + span {
  color: #FF0000;
}
.createTmekaAuth .facebook {
  background-image: url('~@/assets/icon/logo-facebook.png');
}
.createTmekaAuth .facebook + span {
  color: #0000FF;
}
.createTmekaAuth .kakao {
  background-image: url('~@/assets/icon/logo-kakao.png');
}
.createTmekaAuth .kakao + span {
  color: #FFFF00;
}
.createTmekaAuth .naver {
  background-image: url('~@/assets/icon/logo-naver.png');
}
.createTmekaAuth .naver + span {
  color: #00FF99;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/LoginPopup.vue